import "./PricingPortalPage.scss"
import { Helmet } from 'react-helmet-async';
import { useState } from 'react';
import { ExcelTemplateTypes } from "enums";
import { templateConfig } from 'utils';
import TemplateOptions from 'components/TemplateOptions/TemplateOptions';
import OverviewSection from "components/OverviewSection/OverviewSection";
import ViewTemplateSection from "components/ViewTemplateSection/ViewTemplateSection";
import WizardBar from "../../components/Wizard/WizardBar";
import { useRef } from "react";
import { VariableSizeGrid } from "react-window";

// Context Imported
import { ExcelDataProvider } from 'components/Contexts/ExcelDataContext';

export default function PricingPortalPage() {  
    const [templateType, setTemplateType] = useState<ExcelTemplateTypes>(ExcelTemplateTypes.None),
          [isUploading, setIsUploading] = useState(false),
          [changeNotes, setChangeNotes] = useState<string>(''),
          [priceChangeType, setPriceChangeType] = useState<string>(''),
          [isValid, setIsValid] = useState(false),
          [isReviewing, setIsReviewing] = useState(false),
          [supplierLetterIsUploading, setSupplierLetterIsUploading] = useState(false),
          [supplierLetterIsValid, setSupplierLetterIsValid] = useState(false);

    const showWizardBar = templateType === ExcelTemplateTypes.Supplier;

    const gridRef = useRef<VariableSizeGrid>(null);
    const handleScrollToRow = (rowIndex: number) => {
        gridRef.current?.scrollToItem({
            rowIndex,
            align: 'center'
        });

        console.log("test to jump to row: ",  rowIndex)
    };

    return (
        <>
            <Helmet>
                <title>Pricing Portal | Template Drop</title>
            </Helmet>
            <div className="pricingPortalPageWrapper">
                <ExcelDataProvider>
                    <TemplateOptions templateProps={templateConfig}
                                     templateType={templateType}
                                     onTemplateTypeChange={(x) => setTemplateType(x)}
                                     setIsUploading={setIsUploading}
                                     changeNotes={changeNotes}
                                     setChangeNotes={setChangeNotes}
                                     priceChangeType={priceChangeType}
                                     setPriceChangeType={setPriceChangeType}
                                     setIsValid={setIsValid}
                                     setIsReviewing={setIsReviewing}
                                     setSupplierLetterIsUploading={setSupplierLetterIsUploading}
                                     supplierLetterIsValid={supplierLetterIsValid}
                                     setSupplierLetterIsValid={setSupplierLetterIsValid}
                                     onRowErrorClick={handleScrollToRow}
                    />
                    <WizardBar show={showWizardBar}
                               isUploading={isUploading}
                               isValid={isValid}
                               isReviewing={isReviewing}
                               priceChangeType={priceChangeType}
                               supplierLetterIsUploading={supplierLetterIsUploading}
                               validSupplierLetterUploaded={supplierLetterIsValid}

                    />
                    <OverviewSection/>
                    <ViewTemplateSection templateProps={templateConfig}
                                         templateType={templateType}
                                         isUploading={isUploading}
                                         text={changeNotes}
                                         setText={setChangeNotes}
                                         gridRef={gridRef} 
                    />
                </ExcelDataProvider>
            </div>
        </>
    );
}
